import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_LABORATORYFINANCE_LOAD_BY_LABORATORY_ID,
    ACTION_LABORATORYFINANCE_LOAD_BY_ID,

    ACTION_LABORATORYFINANCE_SAVE,

    ACTION_LABORATORYFINANCE_CREATE,

    ACTION_LABORATORYFINANCE_VALIDATE,

    ILaboratoryFinanceLoadByLaboratoryIdAction,
    ILaboratoryFinanceLoadByIdAction,
    ILaboratoryFinanceLoadFailureAction,
    ILaboratoryFinanceLoadSuccessAction,

    ILaboratoryFinanceSaveAction,
    ILaboratoryFinanceSaveSuccessAction,
    ILaboratoryFinanceSaveFailureAction,

    ILaboratoryFinanceCreateAction,
    ILaboratoryFinanceCreateSuccessAction,
    ILaboratoryFinanceCreateFailureAction,

    ILaboratoryFinanceValidateAction,
    ILaboratoryFinanceValidateSuccessAction,
    ILaboratoryFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/laboratoryFinance";
import { laboratoryFinanceApi } from "../services/laboratoryFinance";

export const
    getLaboratoryFinanceByLaboratoryIdEpic = (action$): Observable<ILaboratoryFinanceLoadSuccessAction | ILaboratoryFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYFINANCE_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ILaboratoryFinanceLoadByLaboratoryIdAction) => {
                return laboratoryFinanceApi
                    .getLaboratoryFinanceByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.laboratoryFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryFinanceByIdEpic = (action$): Observable<ILaboratoryFinanceLoadSuccessAction | ILaboratoryFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYFINANCE_LOAD_BY_ID)
            .mergeMap((action: ILaboratoryFinanceLoadByIdAction) => {
                return laboratoryFinanceApi
                    .getLaboratoryFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.laboratoryFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setLaboratoryFinanceEpic = (action$): Observable<ILaboratoryFinanceSaveSuccessAction | ILaboratoryFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYFINANCE_SAVE)
            .mergeMap((action: ILaboratoryFinanceSaveAction) => {
                return laboratoryFinanceApi
                    .setLaboratoryFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.laboratoryFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createLaboratoryFinanceEpic = (action$): Observable<ILaboratoryFinanceCreateSuccessAction | ILaboratoryFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYFINANCE_CREATE)
            .mergeMap((action: ILaboratoryFinanceCreateAction) => {
                return laboratoryFinanceApi
                    .createLaboratoryFinance(action.laboratoryId)
                    .map(response =>
                        CreateSuccess(
                            response.laboratoryFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateLaboratoryFinanceEpic = (action$): Observable<ILaboratoryFinanceValidateSuccessAction | ILaboratoryFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYFINANCE_VALIDATE)
            .mergeMap((action: ILaboratoryFinanceValidateAction) => {
                return laboratoryFinanceApi
                    .validateLaboratoryFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.laboratoryFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }